import React, { useState } from "react";
import ActionButton from "../Button/ActionButton";
import MultiBarChart from "../d3Charts/MultiBarChart/MultiBarChart";
import Loader from "../Loader/Loader";
import "./DatasetTypesDeposited.scss";
import { colorArray } from "../../utils/theme";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";

const DatasetTypesDepositedInner = ({ chartData, isLoading }) => {
  const { get, set, setMultiple } = useCustomSearchParams();
  const [shortName, setShortName] = useState(get(SEARCH_PARAMS.SHORT_NAME));
  return (
    <div className="dtd-wrapper">
      {/* <p className={`dataset-types-deposited-msg-container `}>
        Graph represents the top 10 dataset types associated with the
        publications reporting on funded research. Hover over colored bars to
        see values.
      </p> */}

      <div className="dataset-types-chart">
        <MultiBarChart
          chartData={chartData?.data}
          chartConfig={chartData?.config}
          keys={["countDetails"]}
          chartType="value" //percentage or value
          title={`Top 10 ${shortName} Dataset Types Tracked by CHORUS`}
          notes="Graph represents the top 10 dataset types associated with the publications reporting on funded research. Hover over colored bars to see values."
          colorArray={colorArray}
          wrapInOneLine={true}
        />
      </div>
    </div>
  );
};

const DatasetTypesDeposited = (props) => (
  <ErrorBoundary>
    <DatasetTypesDepositedInner {...props} />
  </ErrorBoundary>
);

export default DatasetTypesDeposited;
